<template>
    <div class="app-container">
        <!-- <el-row style="padding-bottom: 15px">
      <el-col :span="24">
        <h3 class="headtitle">凭证生成</h3>
      </el-col>
    </el-row> -->
        <el-tabs type="border-card" v-model="activetab">
            <el-tab-pane
                v-for="(tab, index) in tabList"
                :label="tab.moduleName"
                :key="index"
                :name="tab.moduleType"
            >
                <component
                    :is="tab.moduleType"
                    :tabType="tab.moduleType"
                    keep-alive
                ></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import voucherPos from '@/views/voucherAdmin/VoucherCreateMutilPos'
import voucherCloud from '@/views/voucherAdmin/voucherCreateCloud'
import voucherZ5 from '@/views/voucherAdmin/voucherCreateZ5'
import voucherCrm from '@/views/voucherAdmin/voucherCreateCrm'
import voucherScm8 from '@/views/voucherAdmin/voucherCreateScm8'
import voucherSaiHu from '@/views/voucherAdmin/voucherCreateSaiHu'

export default {
    name: 'voucherCreate',
    components: {
        voucherPos,
        voucherCloud,
        voucherCrm,
        voucherZ5,
        voucherScm8,
        voucherSaiHu
    },
    data() {
        return {
            activetab: '',
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate',
            tabList: []
        }
    },

    mounted() {
        this.getSysModules()
    },
    methods: {
        getSysModules() {
            const _this = this
            _this.openloading = true
            AjaxHelper.get(_this.VoucherCreateApi + '/getSysModules')
                .then(function (response) {
                    if (response.success) {
                        _this.tabList = response.result
                        console.log(_this.tabList)
                        _this.activetab = _this.tabList[0].moduleType
                    }
                    // _this.openloading = false;
                })
                .catch(function (error) {
                    // _this.openloading = false;
                })
        }
    }
}
</script>

<style scoped>
nav {
    width: 600px;
    /* background: #eeeeee; */
    padding: 0 0px;
}
nav .active {
    background-color: #409eff;
    color: #fff;
}
nav a {
    text-decoration: none;
    color: rgb(0, 0, 0);
    display: inline-block;
    width: 150px;
    border-radius: 5px;
    text-align: center;
    /* background: #fdfcfc; */
    padding: 10px;
    margin-bottom: 15px;
}
.el-tabs--border-card > .el-tabs__content {
    padding: 0 !important ;
}
</style>
